/** @jsxImportSource @emotion/react */
import React from "react";
import { jsx, css } from "@emotion/react";
import { useEffect, useState, forwardRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { loginState, configState } from "../lib/State";
import log from "../lib/log";
import pr from "../lib/pr";
import CenterSelect from "./CenterSelect";
import MemberSearch from "./MemberSearch";
import {
  Select,
  MenuItem,
  AppBar,
  Toolbar,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormLabel,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { ko } from "date-fns/locale";
import moment from "moment";
import ProductSearch from "./ProductSearch";
import { lightGreen } from "@mui/material/colors";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// 등록하기 팝업
function PushEdit(props) {
  
  const { login, seq, onClosePop, onLoadData  } = props;
  const token = localStorage.getItem("token");
  const [centers, setCenters] = useState([]);
  const [showMemberSearch, setShowMemberSearch] = useState(false);
  const [sName, setSname] = useState(""); //*
  const [tcid, setTcid] = useState(""); //*
  const [title, setTitle] = useState(""); //*
  const [tmcd, setTmcd] = useState(""); //*
  const [message, setMessage] = useState(""); //*
  const [type, setType] = useState("선택회원"); //*

  const onSubmit = async () => {
    let result = await axios.post(configState.api + "/gympass_admin/push_edit", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      title: title,
      message: message,
      seq:seq,
    });
    if (result.data.success !== 1) {
      Swal.fire(result.data.msg);
      return;
    } else {
      Swal.fire({ title: "수정되었습니다.", showCloseButton: true }).then(
        (result) => {
          onLoadData();
          onClosePop();
        }
      );
    }
  };

  const onHideMemberSearchClick = () => {
    setShowMemberSearch(false);
  };

  const onAfterMemberSearchClick = (params) => {
    const { id, name } = params;
    setSname(name);
    setTmcd(id);
  };

  // 수업삭제
  const onDelClick = (e) => {
    e.preventDefault();
    Swal.fire({
      title: "삭제 하시겠습니까?",
      showCancelButton: true,
      sconfirmButtonText: "예",
      cancelButtonText: "아니오",
      closeOnCalcel: true,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(configState.api + "/gympass_admin/push_del", {
            seq: seq,
            cid: login.cid,
            mcd: login.mcd,
            token: token,
            level: login.level,
          })
          .then(() => {
            onLoadData();
            onClosePop();
          })
          .catch((e) => alert(e));
      }
    });
  };


  // Load data
  const load_data = async () => {

    let result = await axios.post(
    configState.api + "/gympass_admin/push_one",
    {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      seq: seq,
    });    

    if (result.data.success === 1) {      
        setTitle(result.data.row.title);
        setMessage(result.data.row.message);        
        setTcid(result.data.row.tcid);
    } else {
      Swal.fire(result.data.msg);
      return;
    }

  };

  useEffect(() => {
    load_data();
  }, []);

  return (
    <Box>
      {/* 사용자 팝업 */}
      <Dialog
        open={showMemberSearch}
        onClose={() => {}}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar sx={{ position: "static" }}>
          <Toolbar>
            <Box sx={{ flexGrow: 1 }}>
              <Typography style={{ fontSize: 18 }}>회원찾기</Typography>
            </Box>
            <IconButton
              edge="start"
              color="inherit"
              onClick={onHideMemberSearchClick}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <MemberSearch
          login={login}
          onAfterMemberSearchClick={onAfterMemberSearchClick}
          onHideMemberSearchClick={onHideMemberSearchClick}
        />
      </Dialog>

      <Box sx={{ p: 2 }}>

        {/* 센터명 */}
        <CenterSelect
          tcidParent={tcid}
          setTcidParent={setTcid}
          centers={centers}
          setCenters={setCenters}
          login={login}
        />

        {/* 제목 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="title"
            label="제목"
            size="small"
            autoComplete="off"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
          ></TextField>
        </Box>

        {/* 메세지 */}
        <Box
          css={css`
            margin-top: 10px;
          `}
        >
          <TextField
            name="message"
            label="메세지"
            size="small"
            multiline
            autoComplete="off"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            fullWidth
            rows={4}
          ></TextField>
        </Box>

        <Box
          css={css`
            text-align: center;
            margin-top: 30px;
          `}
        >
          <Button variant="contained" onClick={onSubmit}>
            수정완료
          </Button>
          <Button variant="contained" onClick={onDelClick} sx={{ ml: 1 }}>
            삭제
          </Button>
          <Button
            variant="contained"
            color="warning"
            css={css`
              margin-left: 10px;
            `}
            onClick={onClosePop}
          >
            취소
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default PushEdit;
